/* eslint-disable */
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { confirmationTypeResponse, confirmRes, ConfirmsStatusUpdateResponse, OktaGroups } from 'src/app/models/confirms.model';
import { environment } from '../../../environments/environment';
import { UpdateConfirmationStatus } from '../../models/update-confirmation-status.model';
import { CookieService } from 'ngx-cookie-service';
import { Addresses } from '../../dto/address.interface';

const httpOptions = {
  withCredentials: true,
};

@Injectable({
  providedIn: 'root'
})


export class ConfirmService {
  constructor(
    private readonly http: HttpClient,
    private readonly cookie: CookieService
  ) {
  }

  getConfirms(data): Observable<confirmRes> {
    const endpoint = `${environment.CONFIRMATIONS.BASE_URL}${environment.CONFIRMATIONS.CONSUMER_ENDPOINT}`;
    httpOptions['params'] = data;
    httpOptions['headers'] = {
      'urlFlag': 'getStatements'
    };
    return this.http.get<confirmRes>(endpoint, httpOptions);
  }
  getConfirmTypes(): Observable<confirmationTypeResponse> {
    const endpoint = `${environment.CONFIRMATIONS.BASE_URL}${environment.CONFIRMATIONS.CONFIRMATION_TYPES}`;
    httpOptions['params'] = null;
    httpOptions['headers'] = {
      'urlFlag': 'getConfirmTypes'
    };
    return this.http.get<confirmationTypeResponse>(endpoint, httpOptions);
  }
  downloadPdf(confirmationId: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('confirmationId', confirmationId);
    headers = headers.set('urlFlag', 'getPdf');
    const endpoint = `${environment.CONFIRMATIONS.BASE_URL}${environment.CONFIRMATIONS.PDF_URL}`;
    return this.http.get(endpoint, { headers, responseType: 'blob' });
  }

  async updateConfirmationStatus(updateConfirmationStatus: UpdateConfirmationStatus[]): Promise<ConfirmsStatusUpdateResponse> {
    const endpoint = `${environment.CONFIRMATIONS.BASE_URL}${environment.CONFIRMATIONS.UPDATE_CONFIRMATION_STATUS}`;
    return this.http.patch<ConfirmsStatusUpdateResponse>(endpoint, updateConfirmationStatus,
      {
        headers: {
          'X-XSRF-TOKEN': this.cookie.get('XSRF-TOKEN'),
          'urlFlag': 'updateStatus'
        },
        withCredentials: true
      }
    ).toPromise();
  }

  getAddresses(isInterestedParty: boolean): Observable<Addresses> {
    // Comment out the actual API call
    const endpoint = `${environment.CONFIRMATIONS.BASE_URL}${environment.CONFIRMATIONS.ADDRESS_URL}`;
    const params = new HttpParams().set('isInterestedParty', String(isInterestedParty));
    return this.http.get(endpoint, { params });
  }

  submitConfirmationReprint(data: any): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('urlflag','submitConfirmationReprint');
    headers = headers.set('X-XSRF-TOKEN',this.cookie.get('XSRF-TOKEN'));
    const endpoint = `${environment.CONFIRMATIONS.BASE_URL}${environment.CONFIRMATIONS.SUBMIT_CONFIRMATION_URL}`;
    return this.http.post(endpoint, data, { headers, withCredentials: true });
  }

  async getOktaGroups(): Promise<OktaGroups> {
    const endpoint = `${environment.CONFIRMATIONS.BASE_URL}${environment.CONFIRMATIONS.OKTA_GROUP_URL}`;
    return this.http.get<OktaGroups>(endpoint).toPromise();
  }
}
